
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Koregaonparktomumbaicab() {



    const cardData =
    {
        keyword: ' Koregaon Park to Mumbai Cab',
        heading: 'Prince Cabs: Koregaon Park to Mumbai Cab',
        headingDescription: 'Prince Cabs provides dependable Koregaon Park to Mumbai Cab services, perfect for airport transfers, business travel, family trips, and outstation journeys. Our fleet of well-maintained sedans, SUVs, and luxury cars ensures a safe and comfortable ride from Koregaon Park to Mumbai via the expressway. With professional chauffeurs, punctual pickups, and flexible booking options, we make your travel smooth and hassle-free. Experience comfort, reliability, and affordability with Prince Cabs’ trusted cab service from Koregaon Park to Mumbai.',

        top: 'Top Places to Visit in Mumbai with Prince Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India, built in 1924, is Mumbai’s most iconic landmark overlooking the Arabian Sea. Constructed in Indo-Saracenic style, it commemorates the visit of King George V and Queen Mary. The site is a bustling hub with tourists, photographers, and ferry rides to Elephanta Caves. At sunset, the arch glows beautifully against the skyline. It remains the proud symbol of South Mumbai. Gateway of India is the city’s historic and cultural centerpiece."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, also known as the Queen’s Necklace, is a 3.6 km crescent-shaped boulevard along the Arabian Sea. Locals and tourists flock here for evening walks, sea breezes, and stunning sunsets. At night, its streetlights resemble a sparkling necklace. During monsoon, waves dramatically crash against the promenade. It reflects the modern, vibrant spirit of Mumbai. Marine Drive is the heart of the city’s leisure life."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "CST, formerly Victoria Terminus, is a UNESCO World Heritage railway station built in 1887. Its Gothic Revival architecture features domes, spires, stained glass windows, and intricate carvings. The building looks spectacular when illuminated at night. It is both a functional transport hub and a heritage monument. Tourists admire its grandeur while witnessing Mumbai’s lifeline—the local trains. CST symbolizes Mumbai’s blend of history and modernity."
  },
  {
    "title": "Elephanta Caves",
    "description": "Elephanta Caves, located on Elephanta Island, are UNESCO-listed rock-cut temples dating to the 5th–6th centuries. The highlight is the magnificent Trimurti sculpture of Lord Shiva. The caves reflect India’s ancient artistry and spiritual traditions. Accessible by ferry from Gateway of India, the island offers peace away from the city. Lush greenery surrounds the caves, enhancing their charm. It is a must-visit for history and culture lovers."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is Mumbai’s most famous beach, popular for street food and leisure walks. Vendors serve local delights like pav bhaji, bhel puri, and ice gola. Families gather in the evenings to enjoy the sea breeze and sunset. Bollywood celebrities residing nearby make it a star-spotting zone. The beach is lively with children playing and locals exercising. Juhu Beach is Mumbai’s vibrant coastal escape."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most visited shrines, dedicated to Lord Ganesha. Built in 1801, it attracts devotees, celebrities, and politicians daily. The golden dome and beautifully carved wooden doors add grandeur. Tuesdays are especially crowded with worshippers. Devotees believe wishes made here are fulfilled. Siddhivinayak Temple is the spiritual core of Mumbai."
  },
  {
    "title": "Bandra–Worli Sea Link",
    "description": "The Bandra–Worli Sea Link is an eight-lane cable-stayed bridge and an engineering marvel. It connects South Mumbai with the western suburbs, reducing travel time significantly. The bridge offers stunning views of the Arabian Sea and skyline. At night, its illuminated structure looks spectacular. Driving across the Sea Link is a thrilling experience. It is a modern symbol of Mumbai’s progress."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah, built in the 15th century, is a revered shrine located on an islet in the Arabian Sea. Dedicated to Pir Haji Ali Shah Bukhari, it is a blend of spirituality and architecture. The dargah is connected by a causeway accessible at low tide. Devotees from all religions visit to seek blessings. Its sea-facing setting creates a serene atmosphere. Haji Ali is Mumbai’s iconic spiritual landmark."
  },
  {
    "title": "Colaba Causeway",
    "description": "Colaba Causeway is Mumbai’s bustling street market and shopping paradise. Visitors shop for clothes, handicrafts, jewelry, and antiques at bargain prices. Iconic cafés like Leopold Café and Café Mondegar add to the charm. The area is always lively with both locals and tourists. Bargaining with street vendors is part of the fun. Colaba Causeway is the ultimate shopping and cultural hotspot of Mumbai."
  },
  {
    "title": "Girgaon Chowpatty",
    "description": "Girgaon Chowpatty is a lively beach in South Mumbai, famous for Ganesh Visarjan celebrations. Families and couples enjoy snacks like pav bhaji, kulfi, and bhel here. The beach is vibrant during evenings and festivals. It offers views of Marine Drive’s arc and the Arabian Sea. Children love playing in the sand and waves. Girgaon Chowpatty is Mumbai’s blend of tradition and leisure."
  },
  {
    "title": "Film City, Goregaon",
    "description": "Film City in Goregaon is the hub of Bollywood filmmaking, spread over 500 acres. It has studios, artificial sets, and shooting zones for films and TV shows. Guided tours take visitors behind the scenes of movie production. Cinema lovers enjoy spotting live shoots. It is one of the largest film complexes in the world. Film City showcases Mumbai’s entertainment identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "Sanjay Gandhi National Park is a vast green sanctuary within Mumbai, covering 87 sq. km. It is home to leopards, deer, and hundreds of bird species. Inside the park, the Kanheri Caves display Buddhist stupas and rock-cut monasteries dating back to the 1st century BC. Visitors enjoy safaris, toy train rides, and treks. It is rare to find such nature in a metro. This park blends history, wildlife, and adventure."
  },
  {
    "title": "Powai Lake",
    "description": "Powai Lake is an artificial lake surrounded by greenery and skyscrapers. It is popular among birdwatchers, with species like herons and kingfishers often spotted. Joggers and photographers enjoy its promenade. During monsoon, the lake looks especially scenic with misty surroundings. It is a peaceful retreat within the bustling city. Powai Lake is Mumbai’s hidden natural gem."
  },
  {
    "title": "Global Vipassana Pagoda",
    "description": "The Global Vipassana Pagoda near Gorai is one of the world’s largest meditation domes. Built in Burmese architectural style, it houses relics of Buddha. The golden dome accommodates thousands of meditators. Visitors attend meditation sessions and admire the grand design. Its seaside setting enhances tranquility. The pagoda symbolizes peace, spirituality, and harmony."
  },
  {
    "title": "Nehru Planetarium & Science Centre",
    "description": "Nehru Planetarium in Worli is an educational hub for astronomy enthusiasts. Sky shows inside its dome theatre explain stars, galaxies, and cosmic wonders. The adjoining Science Centre offers interactive exhibits on innovation and technology. Families and students find it educational yet entertaining. Special events are held during eclipses and celestial events. It is Mumbai’s hub of science and curiosity."
  }
],

"services": [
  {
    "name": "Koregaon Park to Mumbai Cab Service",
    "description": "Reliable cab service from Koregaon Park to Mumbai offering comfortable rides with professional drivers. Ideal for daily commuters, business travelers, and families looking for safe and timely transportation between the two cities."
  },
  {
    "name": "Koregaon Park to Mumbai Airport Drop",
    "description": "Ensure timely arrival at the airport with our dedicated Koregaon Park to Mumbai airport drop service. We provide clean, air-conditioned vehicles and experienced drivers to get you to your flight on time, stress-free."
  },
  {
    "name": "Koregaon Park to Mumbai Crysta Taxi",
    "description": "Travel in style with our Innova Crysta taxi service from Koregaon Park to Mumbai. Spacious, comfortable, and perfect for group or family travel with premium interiors and smooth rides for longer distances."
  },
  {
    "name": "Koregaon Park to Mumbai One Way Cab",
    "description": "Book affordable one-way cab rides from Koregaon Park to Mumbai, perfect for single trips without worrying about return fares. Our service is transparent, reliable, and hassle-free for airport drops, meetings, or personal travel."
  },
  {
    "name": "Koregaon Park to Mumbai Etios Cab",
    "description": "Choose Toyota Etios cabs for economical and comfortable travel from Koregaon Park to Mumbai. Ideal for small families or solo travelers, offering good mileage and a smooth ride."
  },
  {
    "name": "Koregaon Park to Mumbai Dzire Taxi",
    "description": "Affordable and comfortable Dzire taxi service from Koregaon Park to Mumbai. Great for individuals and small groups looking for a reliable sedan ride with AC comfort and professional drivers."
  },
  {
    "name": "Koregaon Park to Mumbai Family Cab",
    "description": "Safe and spacious family cab services from Koregaon Park to Mumbai, designed to accommodate families traveling with children. Our vehicles are well-maintained and driven by courteous, experienced drivers."
  },
  {
    "name": "Koregaon Park to Mumbai Ertiga Cab",
    "description": "Hire an Ertiga cab from Koregaon Park to Mumbai for a spacious 7-seater option that combines comfort with affordability. Suitable for groups and family travel, it offers ample luggage space and smooth driving experience."
  },
  {
    "name": "Koregaon Park to Mumbai SUV Taxi",
    "description": "Book an SUV taxi from Koregaon Park to Mumbai for a powerful and comfortable journey. Perfect for rugged roads, larger groups, or travelers seeking extra space and luxury in their commute."
  },
  {
    "name": "Koregaon Park to Mumbai Cab Charges",
    "description": "Transparent and competitive cab charges from Koregaon Park to Mumbai, ensuring value for money. Our fare structure is clear with no hidden fees, making budgeting easy for all types of travelers."
  },
  {
    "name": "Koregaon Park to Mumbai Car Rental",
    "description": "Flexible car rental options from Koregaon Park to Mumbai, including hourly, daily, and long-term rentals. Choose from a variety of vehicles with or without drivers to suit your travel plans."
  },
  {
    "name": "Koregaon Park to Mumbai Tempo Traveller",
    "description": "Rent a Tempo Traveller from Koregaon Park to Mumbai for large group travel. Comfortable seating for 9-12 passengers, ample luggage space, and ideal for corporate trips, weddings, or group tours."
  },
  {
    "name": "Koregaon Park to Mumbai Tour Cab",
    "description": "Plan your sightseeing or corporate tour with our tour cab service from Koregaon Park to Mumbai. Enjoy flexible itineraries, comfortable vehicles, and professional drivers for a hassle-free travel experience."
  },
  {
    "name": "Luxury Cab from Koregaon Park to Mumbai",
    "description": "Experience premium travel with our luxury cab services from Koregaon Park to Mumbai. Choose from top-end sedans and SUVs offering plush interiors, privacy, and exceptional service for business executives and VIPs."
  },
  {
    "name": "Koregaon Park to Mumbai Outstation Taxi",
    "description": "Reliable outstation taxi service from Koregaon Park to Mumbai for one-way or round trips. Our well-maintained fleet and experienced drivers ensure safe, timely, and comfortable journeys for all travel needs."
  }
],
"tableData": [
  ["Koregaon Park to Mumbai Cab Service", "Koregaon Park to Mumbai Airport Drop"],
  ["Koregaon Park to Mumbai Crysta Taxi", "Koregaon Park to Mumbai One Way Cab"],
  ["Koregaon Park to Mumbai Etios Cab", "Koregaon Park to Mumbai Dzire Taxi"],
  ["Koregaon Park to Mumbai Family Cab", "Koregaon Park to Mumbai Ertiga Cab"],
  ["Koregaon Park to Mumbai SUV Taxi", "Koregaon Park to Mumbai Cab Charges"],
  ["Koregaon Park to Mumbai Car Rental", "Koregaon Park to Mumbai Tempo Traveller"],
  ["Koregaon Park to Mumbai Tour Cab", "Luxury Cab from Koregaon Park to Mumbai"],
  ["Koregaon Park to Mumbai Outstation Taxi"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Koregaon Park to Mumbai Cab Service",
    "WhyChoosedescription": "Prince Cabs provides trustworthy and punctual cab services from Koregaon Park, Pune to Mumbai. Known for its vibrant cultural scene and premium residences, Koregaon Park is an ideal pickup point for travelers seeking a smooth and comfortable journey to Mumbai’s various destinations including business districts, tourist spots, and airports."
  },
  {
    "WhyChooseheading": "Variety of Vehicles to Suit Your Travel Needs",
    "WhyChoosedescription": "Our fleet includes a wide range of vehicles like sedans (Swift Dzire, Honda Amaze) and SUVs (Innova Crysta, Ertiga), perfectly suited for solo travelers, families, and groups. All vehicles are air-conditioned, well-maintained, and spacious, ensuring a pleasant and relaxed ride from Koregaon Park to Mumbai."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing is clear and competitive, covering all essential costs such as fuel, tolls, driver allowance, and taxes. With Prince Cabs, you get honest fares without any surprise charges, allowing you to plan your travel budget confidently whether for one-way trips or round trips."
  },
  {
    "WhyChooseheading": "Convenient and Flexible Booking Options",
    "WhyChoosedescription": "Booking a cab from Koregaon Park to Mumbai is easy with multiple options available including phone calls, WhatsApp messages, and online bookings. We offer instant confirmations, flexible cancellation, and rescheduling policies to accommodate your travel plans seamlessly."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are trained professionals familiar with the Pune to Mumbai route, traffic conditions, and best shortcuts. They ensure your safety, provide courteous service, and assist with luggage, making your journey smooth and stress-free."
  },
  {
    "WhyChooseheading": "Sanitized and Well-Maintained Vehicles",
    "WhyChoosedescription": "Ensuring your safety and comfort, our vehicles undergo regular maintenance and thorough sanitization before each trip. Equipped with essential safety features like seat belts and airbags, our cabs provide a clean and secure environment throughout your ride."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
    "WhyChoosedescription": "Prince Cabs offers round-the-clock customer support to help you with bookings, itinerary changes, and any travel-related assistance. Our dedicated team ensures your Koregaon Park to Mumbai cab journey is convenient, reliable, and worry-free."
  }
]


























    }

const faqData = [
    {
        question: 'Does Prince Cabs provide cab services from Koregaon Park to Mumbai?',
        answer: 'Yes, Prince Cabs offers dependable and comfortable cab services from Koregaon Park, Pune to Mumbai for both one-way and round trips.',
    },
    {
        question: 'What vehicle options are available for Koregaon Park to Mumbai trips?',
        answer: 'We offer a range of vehicles including Swift Dzire, Innova, Ertiga, and Tempo Traveller to suit solo travelers, families, and groups.',
    },
    {
        question: 'How long does it take to travel from Koregaon Park to Mumbai by cab?',
        answer: 'The journey usually takes between 3.5 to 4.5 hours depending on traffic and road conditions.',
    },
    {
        question: 'Can I book a one-way cab from Koregaon Park to Mumbai?',
        answer: 'Yes, Prince Cabs provides flexible one-way and round-trip cab services as per your travel needs.',
    },
    {
        question: 'Are the cabs sanitized and maintained for the Koregaon Park to Mumbai route?',
        answer: 'Absolutely! All vehicles are regularly cleaned, sanitized, and serviced for your safety and comfort.',
    },
    {
        question: 'What are the cab fare charges for Koregaon Park to Mumbai?',
        answer: 'Fares vary based on vehicle type and distance. Please contact Prince Cabs for a personalized and competitive fare estimate.',
    },
    {
        question: 'How do I book a cab from Koregaon Park to Mumbai?',
        answer: 'You can book easily via our website or by calling our customer support team with your travel details.',
    },
];

const testimonials = [
    {
        name: "Mr. Suresh Patil",
        position: "Business Traveler",
        text: "I booked a cab from Koregaon Park to Mumbai with Prince Cabs. The vehicle was clean and the driver professional.",
        image: "/img/testimonial/testimonial-thumb-koregaon-mumbai-1.png",
    },
    {
        name: "Ms. Riya Desai",
        position: "Leisure Traveler",
        text: "Prince Cabs made my trip from Koregaon Park to Mumbai smooth and comfortable. Highly recommended!",
        image: "/img/testimonial/testimonial-thumb-koregaon-mumbai-2.png",
    },
];









































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];



const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Koregaon Park to Mumbai Cab",
  "description": "Premium and affordable cab service from Koregaon Park to Mumbai including Airport Drop, One Way, Round Trip, and Outstation options. Choose from Innova Crysta, Dzire, Etios, Ertiga, SUV, and Tempo Traveller.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Koregaon Park",
      "addressRegion": "Pune, Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Koregaon Park to Mumbai Cab Service",
    "Koregaon Park to Mumbai Airport Drop",
    "Koregaon Park to Mumbai Crysta Taxi",
    "Koregaon Park to Mumbai One Way Cab",
    "Koregaon Park to Mumbai Etios Cab",
    "Koregaon Park to Mumbai Dzire Taxi",
    "Koregaon Park to Mumbai Family Cab",
    "Koregaon Park to Mumbai Ertiga Cab",
    "Koregaon Park to Mumbai SUV Taxi",
    "Koregaon Park to Mumbai Cab Charges",
    "Koregaon Park to Mumbai Car Rental",
    "Koregaon Park to Mumbai Tempo Traveller",
    "Koregaon Park to Mumbai Tour Cab",
    "Luxury Cab from Koregaon Park to Mumbai",
    "Koregaon Park to Mumbai Outstation Taxi"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};





    return (
        <div>
<Helmet>
  <title>Koregaon Park to Mumbai Cab | Airport Drop, Crysta, Dzire, SUV</title>
  <meta
    name="description"
    content="Book Koregaon Park to Mumbai cabs including Innova Crysta, Dzire, Etios, Ertiga, SUV, and Tempo Traveller. One Way, Round Trip, Airport Drop, and Outstation Taxi Service available."
  />
  <meta
    name="keywords"
    content="Koregaon Park to Mumbai Cab Service, Koregaon Park to Mumbai Airport Drop, Koregaon Park to Mumbai Crysta Taxi, Koregaon Park to Mumbai One Way Cab, Koregaon Park to Mumbai Etios Cab, Koregaon Park to Mumbai Dzire Taxi, Koregaon Park to Mumbai Family Cab, Koregaon Park to Mumbai Ertiga Cab, Koregaon Park to Mumbai SUV Taxi, Koregaon Park to Mumbai Cab Charges, Koregaon Park to Mumbai Car Rental, Koregaon Park to Mumbai Tempo Traveller, Koregaon Park to Mumbai Tour Cab, Luxury Cab from Koregaon Park to Mumbai, Koregaon Park to Mumbai Outstation Taxi"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/65.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Koregaonparktomumbaicab ;